import * as Immutable from "immutable";
export default class WidgetFormattingSettings {
  constructor(chartColors) {
    this._value = { chartColors };
  }
  get chartColors() {
    return this._value.chartColors;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(chartColors) {
    return new WidgetFormattingSettings(chartColors);
  }
  static builder() {
    return new Builder().chartColors({});
  }
  static empty() {
    return WidgetFormattingSettings.builder().build();
  }
  toJSON() {
    const { chartColors } = this._value;
    const chartColorJson = Object.keys(chartColors).map((fieldName) => ({
      field_name: fieldName,
      chart_color: chartColors[fieldName]
    }));
    return { chart_colors: chartColorJson };
  }
  static fromJSON(value) {
    const { chart_colors: chartColorJson } = value;
    const chartColors = Object.fromEntries(
      chartColorJson.map(({ field_name: fieldName, chart_color: chartColor }) => [fieldName, chartColor])
    );
    return WidgetFormattingSettings.create(chartColors);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  chartColors(value) {
    return new Builder(this.value.set("chartColors", value));
  }
  build() {
    const { chartColors } = this.value.toObject();
    return new WidgetFormattingSettings(chartColors);
  }
}
